import { ArrowLeftOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Typography,
  message,
} from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;
const { Option } = Select;

const AddRegionalManager = () => {
  const navigate = useNavigate();
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  const [form] = Form.useForm();
  const [regions, setRegions] = useState([]);

  useEffect(() => {
    if (token) {
      fetchRegions();
    } else {
      message.error("Session expired, please login again");
    }
  }, [token]);

  const fetchRegions = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASEURL}/region`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRegions(res.data || []);
    } catch (err) {
      message.error("Failed to load regions");
    }
  };

  const handleSubmit = async (values) => {
    const payload = {
      employeeName: values.employeeName,
      password: values.password,
      employeeCode: values.employeeCode,
      contactNumber: values.contactNumber,
      email: values.email,
      regions: values.regionIds,
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASEURL}/regional-manager`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      message.success("Regional Manager added successfully");
      navigate("/regional-managers");
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Failed to add regional manager";
      message.error(errorMsg);
    }
  };

  return (
    <div className="p-4">
      <Card title="Add Regional Manager" >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          {/* Row 1 */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<Text strong>Regional Manager Name</Text>}
                name="employeeName"
                rules={[{ message: "Please enter name" }]}
              >
                <Input placeholder="Ex: John Doe" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<Text strong>Regional Manager Password</Text>}
                name="password"
                rules={[
                  { message: "Please enter password" },
                  { min: 6, message: "Password must be at least 6 characters" },
                ]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>
            </Col>
          </Row>

          {/* Row 2 */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<Text strong>Employee Code</Text>}
                name="employeeCode"
                rules={[{ message: "Please enter employee code" }]}
              >
                <Input placeholder="Ex: EMP101" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<Text strong>Phone</Text>}
                name="contactNumber"
                rules={[
                  { message: "Please enter phone number" },
                  {
                    pattern: /^\d{10}$/,
                    message: "Phone number must be 10 digits",
                  },
                ]}
              >
                <Input placeholder="Ex: 0987654321" />
              </Form.Item>
            </Col>
          </Row>

          {/* Row 3 */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<Text strong>Email</Text>}
                name="email"
                rules={[
                  { type: "email", message: "Enter a valid email" },
                ]}
              >
                <Input placeholder="Ex: john@email.com" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<Text strong>Regions</Text>}
                name="regionIds"
                rules={[{ required: true, message: "Please select at least one Region." }]}
              >
                <Select
                  mode="multiple"
                  showSearch
                  placeholder="Select Regions"
                  optionFilterProp="children"
                >
                  {regions.map((r) => (
                    <Option key={r._id} value={r._id}>
                      {r.regionName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {/* Buttons */}
          <Row>
            <Col>
              <Button
                type="primary"
                htmlType="submit"
                icon={<PlusOutlined />}
                style={{ backgroundColor: PRIMARY_RED, borderColor: PRIMARY_RED }}
              >
                Add Regional Manager
              </Button>
              <Button
                type="link"
                style={{ color: PRIMARY_RED, marginLeft: 10 }}
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate("/regional-managers")}
              >
                Back
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default AddRegionalManager;
